import {formatDate} from '../../../chat.js';

export default (conversation) => jQuery(`
		<div class="friend-drawer friend-drawer--onhover " data-conversation-id="${conversation.id}">
		  <img class="profile-image" src="https://ui-avatars.com/api/?rounded=true&name=Guest" alt="">
		  <div class="text">
			<h6>${conversation.user.meta.name}</h6>
			<p class="last-message text-truncate">${conversation.recent_message ? conversation.recent_message.body.text : ''}</p>
		  </div>
		  <span class="time small d-none">${formatDate(conversation.updated_at)}</span>
		  <span class="unread-count badge badge-primary rounded-pill align-self-center d-none">${conversation.unread_count || ''}</span>
		</div>
	`)
